<dx-popup
  [width]="520"
  [height]="height"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  class="modal"
  [wrapperAttr]="{ class: 'confirmation-dialog-modal' }"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="dismiss()"
>
  <div *dxTemplate="let data of 'content'" class="modal-content">
    <div class="confirmation-container">
      <div class="confirmation-title" *ngIf="options?.title">
        {{options?.title}}
      </div>
      <div class="confirmation-message"
        [innerHTML]="options?.message || ('COMMON.CONFIRMATION-MESSAGE' | translate)">
      </div>
      <div *ngIf="!options?.hideUndo" class="undo-message">
        <i class="dx-icon dx-icon-info"></i>
        {{ 'COMMON.THIS-CANNOT-BE-UNDONE' | translate }}
      </div>
    </div>
  </div>
  <dxi-popup-toolbar-item
    *ngIf="!hideDismissButton"
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      type: 'default',
      text: options?.dismissButtonText || 'COMMON.CANCEL' | translate,
      onClick: dismiss
    }"
  ></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      text: options?.submitButtonText || 'COMMON.CONFIRM' | translate,
      onClick: onSubmit
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>
